<template>
  <v-container>

    <br/>
    <ul id="example-1">
      <li v-for="item in this.$store.state.companyJobs">
        <td width="700px" v-if="item.name==$store.state.patient.jobCompany">
          <v-text-field
                  name="nombre"
                  label="Nombre del Puesto de Trabajo"
                  id="nombrePuesto"
                  :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                  v-model="item.name"
                  required
          ></v-text-field>
        </td>

        <v-data-table v-if="item.name==$store.state.patient.jobCompany"
                      :items="item.jobMeasures"
                      hide-actions
                      hide-headers
        >
          <template slot="items" slot-scope="props1">
            <td v-if="props1.item.agency.name==$store.state.patient.agencyCompany">{{ props1.item.date }}</td>
            <td v-if="props1.item.agency.name==$store.state.patient.agencyCompany">{{ props1.item.agency.name }}</td>
            <td>
              <v-tooltip top >
                <v-btn
                        fab dark
                        small @click="editMeditionObject(props1.item, item)"
                        slot="activator"
                        color="primary">
                  <v-icon dark>search</v-icon>
                </v-btn>
                <span>Editar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </li>
    </ul>
    <v-dialog
            v-model="dialog"
            max-width="800px"
            scrollable>
      <v-card tile>
        <v-toolbar card dark color="nav_background_color">
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Tipos de Medición</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs12 sm4 offset-sm1>
                <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        readonly
                        full-width
                        min-width="290px">
                  <v-text-field
                          slot="activator"
                          v-model="jobMeasure.date"
                          label="Fecha de medición"
                          prepend-icon="event"
                          readonly
                  ></v-text-field>
                  <v-date-picker v-model="jobMeasure.date" @input="$refs.menu.save(jobMeasure.date)"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 sm4 offset-sm1>
                <v-select
                        v-model="jobMeasure.agency"
                        :items="$store.state.companyAgencies"
                        label="Agencia"
                        item-text="name"
                        item-value="id"
                        return-object
                        readonly
                        required
                ></v-select>
              </v-flex>
            </v-layout>
            <br>
            <v-data-table
                    :headers="headers"
                    :items="jobMeasure.jobMeasureDets"
                    class="elevation-1"
                    hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left"><v-text-field
                        name="value"
                        label="Medición"
                        id="val"
                        :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                        v-model="props.item.measure"
                        readonly
                        required
                ></v-text-field></td>
                <td class="text-xs-left"> <v-text-field
                        name="value"
                        label="Valor"
                        id="val"
                        :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                        v-model="props.item.value"
                        readonly
                        required
                ></v-text-field></td>

                <td class="text-xs-left"><v-text-field
                        name="value"
                        label="Unidad"
                        id="val"
                        :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                        v-model="props.item.unit"
                        readonly
                        required
                ></v-text-field></td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
              </v-alert>
            </v-data-table>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>

  export default {
    props: ['company'],
    data() {
      return {
        search: '',
        date:"",
        menu: false,
        valid: false,
        requiredField: [v => !!v || 'Es requerido'],
        dialog: false,
        jobs:[],
        dialogSuccess:false,
        headers: [
          { text: 'Tipo de Medición', value: 'measure' },
          { text: 'Valor', value: 'value' },
          { text: 'Unidad', value: 'unit' },
        ],
        jobMeasures:[],
        jobMeasure:{
          index:-1,
          date:"",
          agency:{},
          job:{},
          jobMeasureDets:[{id:'1',measure:"Ruido - sonometría",value:"",unit:"dB"},{id:'2',measure:"Ruido - dosimetría",value:"",unit:"dB"},{id:'3',measure:"Vibraciones",value:"",unit:"m/s2"},{id:'4',measure:"Condiciones térmicas",value:"",unit:"Grados centígrados"},{id:'5',measure:"Iluminación",value:"",unit:"luxes"},{id:'6',measure:"Material particulado",value:"",unit:"mg/m3"}]
        },
      };
    },
    methods: {
      saveJobs(){
        //Inserta las puestos de trabajo
        for(let i=0;i<this.$store.state.companyJobs.length;i++){
          this.$store.state.companyJobs[i].detail=JSON.stringify(this.$store.state.companyJobs[i].jobMeasures)
          if(this.$store.state.companyJobs[i].id == ""){
            this.$store.dispatch('addCompanyJob',this.$store.state.companyJobs[i]).then(response => {
            }, error => {
              this.$store.state.progress = false
              this.$store.state.dialogError = true
            })
          }else{
            this.$store.dispatch('updateCompanyJob',this.$store.state.companyJobs[i]).then(response => {
            }, error => {
              this.$store.state.progress = false
              this.$store.state.dialogError = true
            })
          }
        }
        this.dialogSuccess = true


      },
      newJob(){
        this.$store.state.companyJobs.push({id:'', name:'', company:this.company, jobMeasures:[]})
      },
      newMedition(){
        this.jobMeasure.jobMeasureDets.push({measure:'', value:'', unit:'', jobMeasure:{id:this.jobMeasure.id}})
      },
      saveMedition(){
        if(this.jobMeasure.id==null){
          this.$store.state.companyJobs[this.jobMeasure.index].jobMeasures.push(this.jobMeasure)
        }
        this.dialog=false;
      },
      deleteMedition(item){
        const index = this.jobMeasure.jobMeasureDets.indexOf(item)
        this.jobMeasure.jobMeasureDets.splice(index, 1)
      },
      editMeditionObject(item, item2){
        const indexJobs = this.$store.state.companyJobs.indexOf(item2)
        let index = this.$store.state.companyJobs[indexJobs].jobMeasures.indexOf(item)
        this.jobMeasure = Object.assign({}, item);
        this.jobMeasure.index=index
        this.dialog=true
      },
      deleteMeditionObject(itemJob, item){
        const index = this.$store.state.companyJobs.indexOf(itemJob)
        const index2= this.$store.state.companyJobs[index].jobMeasures.indexOf(item)
        this.$store.state.companyJobs[index].jobMeasures.splice(index2, 1)
      },
      deleteItemJob(item) {
        const index = this.$store.state.companyJobs.indexOf(item)
        if(Object.assign({}, item).id==""){
          confirm('Está seguro de que quiere eliminar el registro?') &&  this.$store.state.companyJobs.splice(index, 1)

        }else{
          confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deleteCompanyJob',Object.assign({}, item).id).then(response => {
            this.dialogSuccess = true
          }, error => {
            this.$store.state.progress = false
            this.$store.state.dialogError = true
          })
        }

      },
      editItemJob(item) {
        const index = this.$store.state.companyJobs.indexOf(item)
        let job = {id:'', name:'', company:this.company, jobMeasures:[]}
        let jobObject= Object.assign({}, item)
        job.id=jobObject.id
        job.name=jobObject.name
        job.company=jobObject.company
        this.date="",
                this.menu= false,
                this.jobMeasure={
                  index:index,
                  date:"",
                  job:job,
                  agency:{},
                  jobMeasureDets:[{id:'1',measure:"Ruido - sonometría",value:"",unit:"dB"},{id:'2',measure:"Ruido - dosimetría",value:"",unit:"dB"},{id:'3',measure:"Vibraciones",value:"",unit:"m/s2"},{id:'4',measure:"Condiciones térmicas",value:"",unit:"Grados centígrados"},{id:'5',measure:"Iluminación",value:"",unit:"luxes"},{id:'6',measure:"Material particulado",value:"",unit:"mg/m3"}]
                }
        this.dialog=true
      },

    },
    computed: {},
    beforeCreate() {
      this.$store.dispatch('getCompanyJobsByCompany',this.$store.state.patient.company.id)

    }
  };
</script>

<style scoped>
  ul {
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/respiratorio/MonitoreoRespiratorioMedicion.vue